var map = {
	"./bussines--icon.svg": "a226",
	"./compliance--icon.svg": "4bc1",
	"./directory--icon.svg": "4f34",
	"./documental--icon.svg": "ae28",
	"./folios--icon.svg": "d9d8",
	"./holdings--icon.svg": "0d13",
	"./icons/bussines--icon.svg": "e6f8",
	"./icons/compliance--icon.svg": "7512",
	"./icons/directory--icon.svg": "6c40",
	"./icons/documental--icon.svg": "7cac",
	"./icons/folios--icon.svg": "901e",
	"./icons/holdings--icon.svg": "32a9",
	"./icons/insight--icon.svg": "90dc",
	"./icons/outbound--icon.svg": "bb43",
	"./icons/pos--icon.svg": "e7a9",
	"./icons/purchase--icon.svg": "15a5",
	"./icons/shipmate--icon.svg": "3c6f",
	"./insight--icon.svg": "c1fb",
	"./outbound--icon.svg": "f65a",
	"./pos--icon.svg": "0faf",
	"./purchase--icon.svg": "2563",
	"./shipmate--icon.svg": "e760"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1228";